import type { FC, ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';

import type { OpenPopupKeyValue } from 'src/components/followUp/common/types';

interface OpenPopupContextValue {
  openPopupKey: OpenPopupKeyValue;
  setOpenPopupKey: (k: OpenPopupKeyValue) => void;
}
interface OpenPopupProviderProps {
  children?: ReactNode;
}

const initialContextValue = { openPopupKey: null, setOpenPopupKey: () => {} };

const OpenPopupContext =
  createContext<OpenPopupContextValue>(initialContextValue);

export const OpenPopupProvider: FC<OpenPopupProviderProps> = ({ children }) => {
  const [openPopupKey, setOpenPopupKey] = useState<OpenPopupKeyValue>(null);
  return (
    <OpenPopupContext.Provider value={{ openPopupKey, setOpenPopupKey }}>
      {children}
    </OpenPopupContext.Provider>
  );
};

export const useOpenPopup = () => useContext(OpenPopupContext);

export default OpenPopupProvider;
